// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__mnQxg","swiper-wrapper":"Slider_swiper-wrapper__+lhNv","sponsor-swiper":"Slider_sponsor-swiper__5cMix"};